module.exports = __webpack_public_path__ + "static/media/tv-music.074b3523.svg";